import { render, staticRenderFns } from "./ButtonChangePassword.vue?vue&type=template&id=5ae50b7e&scoped=true&"
import script from "./ButtonChangePassword.vue?vue&type=script&lang=js&"
export * from "./ButtonChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ButtonChangePassword.vue?vue&type=style&index=0&id=5ae50b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae50b7e",
  null
  
)

export default component.exports